const MIN_HEADER_SIZE = 110;
const EIOkeys = Object.freeze({
  everything_is_ok_greeting_text: 'everything_is_ok_greeting_text',
  everything_is_ok_text: 'everything_is_ok_text',
  everything_is_ok_error_text: 'everything_is_ok_error_text',
  everything_is_ok_in_progress_text: 'everything_is_ok_in_progress_text',
});

const EIODetailsKeys = Object.freeze({
  everything_is_ok_details_screen_success_text: 'everything_is_ok_details_screen_success_text',
  everything_is_ok_details_screen_error_text: 'everything_is_ok_details_screen_error_text',
  everything_is_ok_details_screen_in_progress_text:
    'everything_is_ok_details_screen_in_progress_text',
});

const DIRECTIONS = {
  up: 'UP',
  down: 'DOWN',
  left: 'LEFT',
  right: 'RIGHT',
};

export { EIOkeys, EIODetailsKeys, DIRECTIONS, MIN_HEADER_SIZE };
